import { Toggle } from "~/ui-rtk/components/ui/controls/Toggle"
import { Image } from "~/ui-rtk/components/ui/common/Image"

import AmazonSvg from "/assets/img/sources/amazon_ads.svg?url"
import { Card, RichTooltip } from "../../common"
import { cn } from "~/ui-rtk/utils/tailwind-utils"
import useConnectedServices from "~/ui-rtk/hooks/connected-services"
import { CONNECTORS_IDS } from "~/ui-rtk/constants/sources"
import { ConnectionStatus } from "~/ui-rtk/api/types"

export default function AmazonToggle({
  amazonEnabled,
  toggleAmazon,
}: {
  amazonEnabled?: boolean
  toggleAmazon: () => void
}) {
  const { findCompanyConnectorInGroup } = useConnectedServices()
  const amazonConnector = findCompanyConnectorInGroup(
    CONNECTORS_IDS.AMAZON_SELLING_PARTNER,
  )
  const amazonVendorConnector = findCompanyConnectorInGroup(
    CONNECTORS_IDS.AMAZON_SELLING_PARTNER_VENDOR,
  )
  const amazonAdsConnector = findCompanyConnectorInGroup(
    CONNECTORS_IDS.AMAZON_ADS,
  )

  const isAmazonConnected =
    amazonConnector?.status === ConnectionStatus.CONNECTED ||
    amazonVendorConnector?.status === ConnectionStatus.CONNECTED ||
    amazonAdsConnector?.status === ConnectionStatus.CONNECTED

  if (!isAmazonConnected) {
    return null
  }

  return (
    <div className="flex justify-end">
      <div
        className={cn(
          "flex items-center gap-system-xs px-system-sm py-system-xxs text-sm rounded-system-md border border-system-blue-600 bg-system-blue-700 h-system-2xl",
        )}
      >
        <RichTooltip
          content={
            <Card rounded className="p-0 bg-transparent border-none">
              Include Estimates for Amazon
            </Card>
          }
        >
          <Image size={20} src={AmazonSvg} alt="amazon icon" />
        </RichTooltip>
        <Toggle size="xs" value={amazonEnabled} onChange={toggleAmazon} />
      </div>
    </div>
  )
}
